/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineItemKey = $(this).attr('data-line-item-key') || $(this).closest('[data-line-item]').data('line-item');
      window.PXUTheme.jsCart.removeFromCart(lineItemKey);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  getCartLine: function (lineItemKey) {
    const key = String(lineItemKey);

    return window.PXUTheme.jsCart.$section.find('[data-cart-item]').filter(function () {
      return $(this).attr('data-cart-item') === key || $(this).attr('data-line-item-key') === key;
    }).first();
  },
  getCartChangeData: function (lineItemKey, quantity) {
    return String(lineItemKey).indexOf(':') > -1
      ? { quantity: quantity, id: lineItemKey }
      : { quantity: quantity, line: lineItemKey };
  },
  removeFromCart: function (lineItemKey) {
    const $cartItem = window.PXUTheme.jsCart.getCartLine(lineItemKey);

    $cartItem.css('opacity', '0.5');
    $cartItem.attr('data-removing', 'true');
    $cartItem.find('.quantity-input').val(0);

    if (window.PXUTheme.updateCartTotals && $cartItem.length) {
      window.PXUTheme.updateCartTotals($cartItem[0]);
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: window.PXUTheme.jsCart.getCartChangeData(lineItemKey, 0),
      dataType: 'json',
      success: function (cart) {
        if (window.PXUTheme.updateCartTotalsFromCart && $cartItem.length) {
          window.PXUTheme.updateCartTotalsFromCart(cart, $cartItem[0]);
        }

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineItemKey);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineItemKey) {

    if (!cart) {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cartData) {
          window.PXUTheme.jsCart.updateView(cartData, lineItemKey);
        }
      });
      return;
    }

    if (window.PXUTheme.updateCartTotalsFromCart) {
      const $sourceLine = lineItemKey ? window.PXUTheme.jsCart.getCartLine(lineItemKey) : null;
      window.PXUTheme.updateCartTotalsFromCart(cart, $sourceLine && $sourceLine.length ? $sourceLine[0] : window.PXUTheme.jsCart.$section[0]);
    }

    if (cart.item_count > 0) {
      $.ajax({
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          // Support both cart page layouts
          var $currentPage = $('.cart-page__list').length > 0 ? $('.cart-page__list') : $('.cart__item-list');
          var $updatedPage = $(html).find('.cart-page__list').length > 0 ? $(html).find('.cart-page__list') : $(html).find('.cart__item-list');
          var itemSelector = $('.cart-page__product').length > 0 ? '.cart-page__product' : '.cart__card';

          if (lineItemKey) {

            var updatedItems = $updatedPage.find(itemSelector);
            var currentItems = $currentPage.find(itemSelector);

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              $currentPage.replaceWith($updatedPage);
            } else {
              var key = String(lineItemKey);
              var updatedItem = $updatedPage.find('[data-cart-item]').filter(function () {
                return $(this).attr('data-cart-item') === key || $(this).attr('data-line-item-key') === key;
              }).first();
              var currentItem = window.PXUTheme.jsCart.getCartLine(lineItemKey);

              if (updatedItem.length && currentItem.length) {
                currentItem.replaceWith(updatedItem);
              }
            }

          } else if ($updatedPage.length && $currentPage.length) {
            $currentPage.replaceWith($updatedPage);
          }

          var subtotalSelector = $('.cart-page__subtotal').length > 0 ? '.cart-page__subtotal' : '.cart__subtotal-container';
          var discountsSelector = $('.cart-page__discounts').length > 0 ? '.cart-page__discounts' : '.cart__discounts';
          var savingsSelector = $('.cart-page__savings').length > 0 ? '.cart-page__savings' : '.cart__total-savings';

          var subtotal = $(html).find(subtotalSelector);
          var discounts = $(html).find(discountsSelector);
          var savings = $(html).find(savingsSelector);

          $(subtotalSelector).replaceWith(subtotal);
          
          if (discounts.length > 0 && $(discountsSelector).length < 1) {
            $(subtotalSelector).before(discounts);
          } else {
            $(discountsSelector).replaceWith(discounts);
          }

          if (savings.length > 0 && $(savingsSelector).length < 1) {
            $(subtotalSelector).after(savings);
          } else {
            $(savingsSelector).replaceWith(savings);
          }

          // Update shipping bar
          var shippingBar = $(html).find('.cart-page__shipping-bar');
          if (shippingBar.length && $('.cart-page__shipping-bar').length) {
            $('.cart-page__shipping-bar').replaceWith(shippingBar);
            $('.cart-page__shipping-bar').removeClass('is-hidden');
          }

          // Update cart page item count
          var itemCount = $(html).find('.cart-page__item-count');
          if (itemCount.length && $('.cart-page__item-count').length) {
            $('.cart-page__item-count').replaceWith(itemCount);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart-page__empty-cart-message, .cart__empty-cart-message').removeClass('is-hidden');
      $('.cart-page__form, .cart__form').addClass('is-hidden');
      $('.cart-page__shipping-bar').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('.action-area__link').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
      $('.cart-page__item-count').text('(0)');
      // Refresh cart page header and subtotal from server
      $.ajax({
        cache: false,
        dataType: 'html',
        url: '/cart',
        success: function (html) {
          var itemCount = $(html).find('.cart-page__item-count');
          var subtotal = $(html).find('.cart-page__subtotal');
          if (itemCount.length && $('.cart-page__item-count').length) {
            $('.cart-page__item-count').replaceWith(itemCount);
          }
          if (subtotal.length && $('.cart-page__subtotal').length) {
            $('.cart-page__subtotal').replaceWith(subtotal);
          }
        }
      });
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;
